import React from 'react';
import { AnswerTypes } from '../../model';

import TypeInput from '../AnswerTypeInput';
import TypeSelect from '../AnswerTypeSelect';
import TypeCountry from '../AnswerTypeCountry';
import TypeNumeric from '../AnswerTypeNumeric';
import TypeAge from '../AnswerTypeAge';
import TypeMonths from '../AnswerTypeMonths';
import TypePlants from '../AnswerTypePlants';
import TypeDimensions from '../AnswerTypeDimensions';

const map = {
	[AnswerTypes.Input]: TypeInput,
	[AnswerTypes.Select]: TypeSelect,
	[AnswerTypes.Country]: TypeCountry,
	[AnswerTypes.Numeric]: TypeNumeric,
	[AnswerTypes.Age]: TypeAge,
	[AnswerTypes.Months]: TypeMonths,
	[AnswerTypes.Plants]: TypePlants,
	[AnswerTypes.Dimensions]: TypeDimensions,
};

function AnswerType(props) {
	const { type, title = null } = props;
	if (map[type]) {
		const C = map[type];
		return <C {...props} />;
	}
	return title;
}

export default AnswerType;


// WEBPACK FOOTER //
// ./src/components/AnswerType/AnswerType.js